<div class="subtopicResult mx-2-5">
    <div class="flex-display">
      <div *ngIf="topic != null" class="searchTopicText bold"><span
          [innerHTML]="topic"></span>
      </div>
    </div>
    <div class="mt_1 display-list" *ngFor="let topics of topicData">
      <div class="pb-1rem" *ngIf="topics.section != null && topics.sectionName != null && topics.subtopic != null && topics.subtopicName != null">
        <div class="flex-display">
          <span *ngIf="topics.subtopic != null && topics.subtopicName != null"
            class="searchTopicText mr_0_5rem font-16 content-blue text-decoration-none">{{topics.subtopic}}
            <span class="mr_0_5rem content-blue text-decoration-none" [innerHTML]="topics.subtopicName"></span>
            <img _ngcontent-uoe-c167="" alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" class="arrow whatsNew-image">
            <a *ngIf="topics.section != null && topics.sectionName != null" (mouseover)="mouseOverFunctions($event, topics.topicId)" (click)="navigateToContent($event, topics.topicId)" (keyup.enter)="navigateToContent($event, topics.topicId)" tabindex="0"
               class="searchTopicText font-16 mr_0_5rem pdf-link pl-05 glossaryTerm">{{topics.section}}&nbsp;{{topics.sectionName}}</a>
          </span>
        </div>
      </div>
    </div>
  </div>
